import Badge from "@mui/material/Badge";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import IconButton from "@mui/material/IconButton";

export default function CartBadge({ count = 1, onClick }) {
    return (
        <IconButton sx={{color: "#000"}} onClick={onClick} aria-label="cart">
            <Badge
                badgeContent={count}
                sx={{
                    "& .MuiBadge-badge": {
                        backgroundColor: "#fbb100",
                        color: "#000",
                    },
                }}
            >        
                <ShoppingBagOutlinedIcon fontSize="large" />
            </Badge>
        </IconButton>
    );
}
